import RegularCard from '../../Molecules/RegularCard/RegularCard'
import FS_HOME_ACERCA_BENEFICIO_SEGURIDAD_ICONO from "../../../assets/img/FS-HOME-ACERCA-BENEFICIO-SEGURIDAD-ICONO.svg";
import FS_TUTORIALES_ICONO_AZUL from "../../../assets/img/FS-TUTORIALES-ICONO-AZUL.svg";
import FS_TUTORIALES_ICONO_AMARILLO from "../../../assets/img/FS-TUTORIALES-ICONO-AMARILLO.svg";
import FS_TUTORIALES_ICONO_MAGENTA from "../../../assets/img/FS-TUTORIALES-ICONO-MAGENTA.svg";
import content from "./content";
import { useLanguageCtx } from '../../../store/providers/LanguageContext';
import { useScrollCtx } from '../../../store/providers/ScrollContext';
import ChangeableHeaderV2 from '../../Molecules/ChangeableHeaderV2/ChangeableHeaderV2';

const Tutorials = () => {
  const {language} = useLanguageCtx();
	const { dropdownHeader } = useScrollCtx();

  return (
		<>
			<ChangeableHeaderV2 basic appearSecondNavbar={dropdownHeader} />
			<div className="max-width ">
				<h2 className="t2 center-text no-space top-space-section">
					{content[language].title}
				</h2>
				<div className="flex space-around wrap top-space-section bottom-space-section">
					<RegularCard
						img={FS_HOME_ACERCA_BENEFICIO_SEGURIDAD_ICONO}
						title={content[language].tutorial_1_title}
						content={content[language].tutorial_default_content}
						linkText={content[language].link_text}
						section="tutorials"
					/>
					<RegularCard
						img={FS_TUTORIALES_ICONO_AZUL}
						title={content[language].tutorial_2_title}
						content={content[language].tutorial_default_content}
						linkText={content[language].link_text}
						section="tutorials"
					/>
					<RegularCard
						img={FS_TUTORIALES_ICONO_AMARILLO}
						title={content[language].tutorial_3_title}
						content={content[language].tutorial_default_content}
						linkText={content[language].link_text}
						section="tutorials"
					/>
					<RegularCard
						img={FS_TUTORIALES_ICONO_MAGENTA}
						title={content[language].tutorial_4_title}
						content={content[language].tutorial_default_content}
						linkText={content[language].link_text}
						section="tutorials"
					/>
					<RegularCard
						img={FS_HOME_ACERCA_BENEFICIO_SEGURIDAD_ICONO}
						title={content[language].tutorial_1_title}
						content={content[language].tutorial_default_content}
						linkText={content[language].link_text}
						section="tutorials"
					/>
					<RegularCard
						img={FS_TUTORIALES_ICONO_AZUL}
						title={content[language].tutorial_2_title}
						content={content[language].tutorial_default_content}
						linkText={content[language].link_text}
						section="tutorials"
					/>
					<RegularCard
						img={FS_TUTORIALES_ICONO_AMARILLO}
						title={content[language].tutorial_3_title}
						content={content[language].tutorial_default_content}
						linkText={content[language].link_text}
						section="tutorials"
					/>
					<RegularCard
						img={FS_TUTORIALES_ICONO_MAGENTA}
						title={content[language].tutorial_4_title}
						content={content[language].tutorial_default_content}
						linkText={content[language].link_text}
						section="tutorials"
					/>
					<RegularCard
						img={FS_HOME_ACERCA_BENEFICIO_SEGURIDAD_ICONO}
						title={content[language].tutorial_1_title}
						content={content[language].tutorial_default_content}
						linkText={content[language].link_text}
						section="tutorials"
					/>
					<RegularCard
						img={FS_TUTORIALES_ICONO_AZUL}
						title={content[language].tutorial_2_title}
						content={content[language].tutorial_default_content}
						linkText={content[language].link_text}
						section="tutorials"
					/>
					<RegularCard
						img={FS_TUTORIALES_ICONO_AMARILLO}
						title={content[language].tutorial_3_title}
						content={content[language].tutorial_default_content}
						linkText={content[language].link_text}
						section="tutorials"
					/>
					<RegularCard
						img={FS_TUTORIALES_ICONO_MAGENTA}
						title={content[language].tutorial_4_title}
						content={content[language].tutorial_default_content}
						linkText={content[language].link_text}
						section="tutorials"
					/>
				</div>
			</div>
		</>
	);
}

export default Tutorials
